module.exports = __webpack_public_path__ + "static/media/male-artist_1f468-200d-1f3a8.7a40828c.png";